import { PageNavItem } from '@/components/models/travel/navs/PageNavigation/types'

const navItemsHook = (items: PageNavItem[]): PageNavItem[] => {
  const orderAndFilter = ['itinerary', 'pricing', 'accommodation', 'guides', 'teams']
  return items
    .filter((item) => orderAndFilter.includes(item.name))
    .sort((a, b) => {
      return orderAndFilter.indexOf(a.name) - orderAndFilter.indexOf(b.name)
    })
}

export default navItemsHook
